import { render, staticRenderFns } from "./CategoryDetailsHeader.vue?vue&type=template&id=2ed1a27d&scoped=true&"
import script from "./CategoryDetailsHeader.vue?vue&type=script&lang=ts&"
export * from "./CategoryDetailsHeader.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryDetailsHeader.vue?vue&type=style&index=0&id=2ed1a27d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed1a27d",
  null
  
)

export default component.exports